export default __webpack_public_path__ + "static/media/tumplate-load-animator1.b8d82f3b.gif";